export const styles = (theme) => ({
  label: {
    display: "inline",
  },
  root: {
    cursor: "pointer",
    display: "flex",
  },
  menuItem:{
    display:"flex",
  }
});
export default styles;
